import { EMPTY_ROOT_CONTAINER_PROPS } from "@client/content/lib/consts";
import { getEntityRef } from "@client/content/lib/helper";
import { type RootContainerProps } from "@client/content/types";
import { connectCustom } from "@client/lib/misc";
import { type AppState } from "@client/types";
import { closeCourseModal } from "../actions";
import { localStateSelector, makeActiveLessonSelector } from "../selectors";
import Component, { type ActionProps, type MapProps } from "./component";

const INVISIBLE_PROPS: MapProps = {
  ...EMPTY_ROOT_CONTAINER_PROPS,

  id: "",
  isLoading: false,
  isVisible: false,
  name: ""
};

const makeMapStateToProps = () => {
  const activeItemSelector = makeActiveLessonSelector();

  return (state: AppState, props: RootContainerProps): MapProps => {
    const localState = localStateSelector(state, props);

    if (!localState.activeCourseId || !localState.activeCourse) return INVISIBLE_PROPS;

    const activeItem = activeItemSelector(state, props);
    const course = localState.activeCourse.course;
    return {
      ...props,

      isLoading: !localState.activeCourse,
      isVisible: true,
      name: `${course.name}${activeItem ? `: ${activeItem.title}` : ""}`
    };
  };
};

const mapDispatchToProps = (dispatch: any, props: RootContainerProps): ActionProps => ({
  onClose: () => dispatch(closeCourseModal(getEntityRef(props)))
});

export default connectCustom(makeMapStateToProps, mapDispatchToProps)(Component);
